import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'var(--bg-primary, #f1f5f9)', padding: 40, textAlign: 'center'
    }}>
      <div style={{ maxWidth: 460 }}>
        <div style={{ fontSize: 72, fontWeight: 800, color: 'var(--text-primary, #1e293b)', letterSpacing: '-2px', lineHeight: 1 }}>
          404
        </div>
        <h1 style={{ margin: '12px 0 8px', fontSize: 22, fontWeight: 700, color: 'var(--text-primary, #1e293b)' }}>
          Page not found
        </h1>
        <p style={{ fontSize: 14, color: 'var(--text-secondary, #64748b)', lineHeight: 1.6, margin: '0 0 24px' }}>
          The page you're looking for doesn't exist or has been moved.
        </p>
        <button onClick={() => navigate('/')} style={{
          padding: '12px 24px', borderRadius: 10, border: 'none', background: '#2563eb',
          color: '#fff', fontSize: 14, fontWeight: 600, cursor: 'pointer',
          display: 'inline-flex', alignItems: 'center', gap: 8,
          boxShadow: '0 4px 12px rgba(37,99,235,0.3)'
        }}>
          <FiArrowLeft size={16} /> Back to Dashboard
        </button>
      </div>
    </div>
  );
}
